import { api } from "@/lib/api-client";

export interface UploadResult {
  key: string;
  url: string;
  mimeType: string;
  sizeBytes: number;
}

export const uploadsApi = {
  image: (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post<UploadResult>("/uploads", formData);
  },
};
